import { Link } from 'react-router-dom';
import { ROUTES } from '../../constants/routes';

const STAR_PATH =
  'M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z';

function PlaylistLectureInfo({ lesson }) {
  return (
    <div className="mt-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
      <div>
        <h2 className="text-lg font-bold text-[#1B1B1B] sm:text-xl">{lesson.title}</h2>
        <div className="mt-3 flex items-center gap-3">
          <img
            src={lesson.instructor.avatar}
            alt={lesson.instructor.name}
            className="h-10 w-10 rounded-full object-cover"
          />
          {lesson.instructor.id ? (
            <Link
              to={ROUTES.TEACHER_DETAIL(lesson.instructor)}
              className="text-sm font-semibold text-[#1B1B1B] transition hover:text-[#9369CC] hover:underline"
            >
              {lesson.instructor.name}
            </Link>
          ) : (
            <span className="text-sm font-semibold text-[#1B1B1B]">{lesson.instructor.name}</span>
          )}
          <span className="flex items-center gap-1 text-sm font-medium text-[#666666]">
            <svg className="h-4 w-4 text-amber-400" fill="currentColor" viewBox="0 0 20 20" aria-hidden>
              <path d={STAR_PATH} />
            </svg>
            {lesson.instructor.rating}
          </span>
        </div>
      </div>

      <div className="flex flex-wrap items-center gap-3 self-start">
        <button
          type="button"
          className="inline-flex items-center gap-2 rounded-full border border-[#D9D9D9] bg-white px-5 py-2 text-sm font-semibold text-[#666666] shadow-sm transition hover:border-[#9369CC] hover:text-[#9369CC]"
        >
          Share
          <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" />
          </svg>
        </button>
      </div>
    </div>
  );
}

export default PlaylistLectureInfo;
